module.exports = __webpack_public_path__ + "img/bess_dis_power.ecac8bb2.svg";